import React, { FunctionComponent, useState } from 'react';
import { ButtonBase, Stack, SxProps, Typography } from '@mui/material';
import moment from 'moment';

import {
  StyledTableCell,
  StyledTableRow,
} from '../../../../../../../components/V2/Table/type1/TableStyles';
import { ILessonHistory } from '../../../../../../../store/V2/LessonHistorySlice';
import ViewZoomRecordingsModal from '../../../../../../../components/Modals/ViewZoomRecordingsModal';
import {
  ISection,
  TSectionZoomRecording,
} from '../../../../../../../store/V2/SectionSlice';
import { getShortName } from '../../../../../../../helper';

interface CompletedLessonHistoryTableRowProps {
  lessonHistory: ILessonHistory;
  onView: () => void;
  onStudentsClick: () => void;
  onTutorsClick: () => void;
}

const actionButtonStyles: SxProps = {
  borderRadius: '8px',
  padding: '10px 12px 10px 12px',
  fontWeight: 600,
  fontSize: '14px',
  maxHeight: '36px',
  backgroundColor: '#006C9C',
  color: '#F8FAFC',
  width: 'fit-content',
};

const CompletedLessonHistoryTableRow: FunctionComponent<CompletedLessonHistoryTableRowProps> = ({
  lessonHistory,
  onView,
  onStudentsClick,
  onTutorsClick,
}) => {
  // State
  const [
    isViewZoomRecordingsModalOpen,
    setViewZoomRecordingsModalOpen,
  ] = useState(false);

  const startMoment = moment(lessonHistory.start);
  const sectionData = lessonHistory.section as ISection;

  let studentsButtonName = '0 Student';
  let tutorsButtonName = '0 Tutor';
  let zoomRecordingsButtonText = '0 Recording';
  let zoomRecordings: TSectionZoomRecording[] = [];

  if (lessonHistory.students && lessonHistory.students.length) {
    if (lessonHistory.students.length === 1) {
      studentsButtonName = getShortName(
        lessonHistory.students[0].firstname,
        lessonHistory.students[0].lastname,
        true
      );
    } else {
      studentsButtonName = `${lessonHistory.students.length} Students`;
    }
  }

  if (lessonHistory.tutors && lessonHistory.tutors.length) {
    if (lessonHistory.tutors.length === 1) {
      tutorsButtonName = getShortName(
        lessonHistory.tutors[0].firstname,
        lessonHistory.tutors[0].lastname
      );
    } else {
      tutorsButtonName = `${lessonHistory.tutors.length} Tutors`;
    }
  }

  if (
    sectionData &&
    sectionData.zoomRecordings &&
    sectionData.zoomRecordings.length
  ) {
    zoomRecordings = sectionData.zoomRecordings;
    const _length = sectionData.zoomRecordings.length;
    zoomRecordingsButtonText = `${_length} Recording${_length > 1 ? 's' : ''}`;
  }

  return (
    <StyledTableRow hover key={lessonHistory._id}>
      {/* <StyledTableCell padding="checkbox">
        <Checkbox checked={selected} onClick={onSelectRow} />
      </StyledTableCell> */}
      <StyledTableCell>
        <Stack>
          <Typography fontSize="14px" fontWeight={500} color="#1E293B">
            {startMoment.format('ddd MMM DD YYYY')}
          </Typography>
          <Typography fontSize="12px" color="#94A3B8">
            {startMoment.format('hh:mm A')}
          </Typography>
        </Stack>
      </StyledTableCell>
      <StyledTableCell>
        <ButtonBase
          sx={{ textDecoration: 'underline' }}
          onClick={onStudentsClick}
        >
          {studentsButtonName}
        </ButtonBase>
      </StyledTableCell>
      <StyledTableCell>
        <ButtonBase
          sx={{ textDecoration: 'underline' }}
          onClick={onTutorsClick}
        >
          {tutorsButtonName}
        </ButtonBase>
      </StyledTableCell>
      <StyledTableCell>
        <ButtonBase
          disabled={!zoomRecordings.length}
          onClick={() => setViewZoomRecordingsModalOpen(true)}
          sx={{ textDecoration: 'underline' }}
        >
          {zoomRecordingsButtonText}
        </ButtonBase>
      </StyledTableCell>
      <StyledTableCell>
        <Stack>
          <ButtonBase sx={{ ...actionButtonStyles }} onClick={onView}>
            View
          </ButtonBase>
        </Stack>
      </StyledTableCell>
      {isViewZoomRecordingsModalOpen ? (
        <ViewZoomRecordingsModal
          open={isViewZoomRecordingsModalOpen}
          onClose={() => setViewZoomRecordingsModalOpen(false)}
          zoomRecordings={zoomRecordings || []}
        />
      ) : null}
    </StyledTableRow>
  );
};

export default CompletedLessonHistoryTableRow;
